import React from "react";
import PropTypes from "prop-types";

export const AttachmentCellFormatter = ({ value }) => <span>{ value.name }</span>;

AttachmentCellFormatter.propTypes = {
  value: PropTypes.shape({
    name: PropTypes.string,
    url: PropTypes.string
  }).isRequired
};



// WEBPACK FOOTER //
// ./src/js/components/grid/cell-formatters/attachment-cell-formatter.jsx